import { compose, ifElse, propEq, always } from 'ramda';

import { CAMPAIGN } from 'app/router/constants/paths';
import { getDecodedParsedSearch } from 'app/router/selectors';

const isContentMigration = compose(
  propEq(CAMPAIGN, 'contentmigration'),
  getDecodedParsedSearch,
);

const titleKey = ifElse(
  isContentMigration,
  always('already_premium_funimation_title'),
  always('already_premium_title'),
);

const subtitleKey = ifElse(
  isContentMigration,
  always('already_premium_funimation_subtitle'),
  always('already_premium_subtitle'),
);

export { titleKey, subtitleKey };
